module.exports = __webpack_public_path__ + "img/bjbank.1bd67af0.png";